import React from 'react';

// 🔑 A RE-READ OF THE STORED CREDIT REPORT — DISPLAY ONLY (Jesse, 2026-10-21 — LOX Tier 1). The events the current
// field mapping reads from the report already on file (GET /api/admin/borrowers/:id/credit-issues → reread). They are
// not the decision record: Atlas, the adverse checks and the borrower's screens still read the last pull's events.
// No dismiss buttons — there is nothing here to act on.
const SEV = { BLOCKING: '#991b1b', SIGNIFICANT: '#92400e', WARNING: '#6b7280' };

export default function CreditRereadSnapshot({ reread }) {
  if (!reread) return null;
  const events = Array.isArray(reread.events) ? reread.events : [];
  const when = reread.at ? new Date(reread.at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
  return (
    <div data-testid="credit-reread-snapshot" style={{ border: '1px dashed #c7d2fe', background: '#f8faff', borderRadius: 8, padding: '10px 12px', margin: '0 0 12px' }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: '#3730a3', marginBottom: 6 }}>
        Re-read from the stored report on {when} — display only. Decisions and the borrower&apos;s view still use the last pull.
      </div>
      {events.length === 0 && <div style={{ fontSize: 12, color: '#6b7280' }}>No credit events read from the stored report.</div>}
      {events.map((e, i) => (
        <div key={i} style={{ fontSize: 12, color: '#374151', marginBottom: 4 }}>
          <strong style={{ color: SEV[String(e.severity).toUpperCase()] || '#374151' }}>{String(e.severity || '').toUpperCase()}</strong>
          {' · '}{String(e.event_type || '').replace(/_/g, ' ')}{' — '}{e.description}
        </div>
      ))}
    </div>
  );
}
